module.exports = __webpack_public_path__ + "static/media/5_ChimeKit-Diagram-No-Back.8e1d3b90.svg";